import React, {useState, useEffect} from "react";
import Button from "react-bootstrap/Button";
import ApiService from "../util/ApiService";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Importando o JS do Bootstrap
import CustomPagination from "../util/CustomPagination";
import Modal from 'react-bootstrap/Modal';
import Select from "react-select";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {Card, CardBody, Col, Container, Row} from "reactstrap";
import {Avatar} from "antd";
import StatesSelect from "../util/StatesSelect";
import HospitalRegisterModal from "./HospitalRegisterModal";
import LoadingScreen from "../util/LoadingScreen";

require("./assets/css/Hospital.css");

const HospitalModal = ({show, handleClose, onHospitalSelect, actionText = "Selecionar"}) => {
    const [hospitals, setHospitals] = useState([]);
    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});
    const [loadingPage, setLoadingPage] = useState(false);

    const [searchTerm, setSearchTerm] = useState("");
    const [showModalHospitalRegister, setShowModalHospitalRegister] = useState(false);
    const [cnpj, setCnpj] = useState("");
    const [cep, setCep] = useState("");
    const [loading, setLoading] = useState(false);
    const [hasSearched, setHasSearched] = useState(false); // Flag para controlar se a busca foi realizada
    const pageSize = 15;

    const [ufs, setUfs] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedUf, setSelectedUf] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [assistant, setAssistant] = useState(null);

    // Função para buscar hospitais
    const fetchHospitals = async (page = 1) => {
        setLoading(true);
        try {
            const params = {
                per_page: pagination.pageSize,
                page: page,
                name: searchTerm,
                cnpj: cnpj,
                uf: selectedUf ? selectedUf.value : '',  // Passa o código da UF selecionada
                id_city: selectedCity ? selectedCity.value : '',  // Passa o ID da cidade selecionada
            };

            const response = await ApiService.send("post", `${process.env.REACT_APP_URL_API}hospitals/search-company`, params, false);

            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setHospitals(data || []);
            setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});

            // Marca que a busca foi realizada
            setHasSearched(true);

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoading(false);
        }
    };

    const formatCnpj = (value) => {
        value = value.replace(/\D/g, ''); // remove tudo que não for número

        return value
            .replace(/^(\d{2})(\d)/, '$1.$2')
            .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
            .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3/$4')
            .replace(/^(\d{2})\.(\d{3})\.(\d{3})\/(\d{4})(\d{2}).*/, '$1.$2.$3/$4-$5');
    };


    const handleUfChange = (selectedOption) => {
        setSelectedUf(selectedOption);
        setSelectedCity(null);  // Limpa a cidade ao alterar a UF

        if (selectedOption) {
            ApiService.send("post", process.env.REACT_APP_URL_API + "address/city-uf", {uf: selectedOption.value}, false)
                .then((res) => {
                    const data = res.data;
                    if (!data.errors) {
                        setCities(
                            data.map((city) => ({
                                value: city.id,  // Agora usa `id` da cidade
                                label: city.name,
                                latitude: city.latitude,
                                longitude: city.longitude,
                            }))
                        );
                    }
                })
                .catch((error) => {

                });
        } else {
            setCities([]);
        }
    };


    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleCepChange = (e) => {
        setCep(e.target.value);
    };

    const handleSearchClick = () => {
        setCurrentPage(1);
        fetchHospitals(1); // Faz a busca na API quando o botão de buscar é clicado
    };

    const handleModalRegister = () => {
        setShowModalHospitalRegister(true);
    };

    const handleCloseModalRegister = (save = false) => {
        setShowModalHospitalRegister(false);
        if (save) {
            handleClose(save);
        }
    };

    const handleSelectHospital = (hospital) => {

        const formattedSuggestions = {
            value: hospital.id, // Supondo que você tenha um ID único para cada hospital
            label: hospital.name,
            city: hospital.city_name,
            uf: hospital.uf,
        };

        onHospitalSelect(formattedSuggestions);
    };

    const handleCompanyAssistant = async () => {

        try {
            // Enviar requisição para registrar o hospital para o usuário
            setLoadingPage(true);
            const response = await ApiService.send(
                "get", // Alterei para "post" caso esteja criando o registro
                `${process.env.REACT_APP_URL_API}users/list-assistant`,
                null,
                true
            );
            const {data} = ApiService.handleApiResponse(response);
            console.log(data);
            setAssistant(data);

        } catch (error) {
            setLoadingPage(false);
            ApiService.handleApiError(error);
        } finally {
            setLoadingPage(false);
        }

    };


    useEffect(() => {
        handleCompanyAssistant();
    }, []);

    const handlePageChange = (page) => {
        setCurrentPage(page);
        fetchHospitals(page); // Busca de acordo com a paginação
    };

    return (
        <>
            {loadingPage && <LoadingScreen/>}
            <Modal show={show} onHide={handleClose} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Buscar Local</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row mb-3">
                        <div className="col-7">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Buscar por nome"
                                value={searchTerm}
                                onChange={handleSearchChange}
                            />
                        </div>
                        <div className="col-5">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="CNPJ"
                                value={cnpj}
                                onChange={(e) => {
                                    const raw = e.target.value.replace(/\D/g, '');
                                    const formatted = formatCnpj(raw);
                                    setCnpj(formatted);
                                }}
                                maxLength={18}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-4">
                            <StatesSelect value={selectedUf} onChange={handleUfChange}/>
                        </div>
                        <div className="col-8">
                            <Select
                                value={selectedCity}
                                onChange={setSelectedCity}  // Armazena a cidade selecionada
                                options={cities}
                                placeholder="Selecione a Cidade"
                                isDisabled={!selectedUf}
                                isSearchable
                                menuPortalTarget={document.body} // Renderiza o menu fora do contêiner pai
                                styles={{
                                    menuPortal: base => ({
                                        ...base,
                                        zIndex: 9999
                                    }), // Definindo z-index alto
                                    menu: base => ({...base, zIndex: 9999}) // Ajuste de z-index no próprio menu
                                }}
                            />
                        </div>
                    </div>
                    <div className="d-flex justify-content-end mb-3">
                        <button type="button" className="btn btn-primary" onClick={() => fetchHospitals(1)}
                                disabled={loading}>
                            {loading ? (
                                <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"
                                      aria-hidden="true"></span>
                                    Buscando...
                                </>
                            ) : (
                                <>
                                    <i className="fa fa-search"></i> Buscar
                                </>
                            )}
                        </button>
                    </div>

                    <Row className="gy-2 mb-2" id="candidate-list">
                        {loading ? (
                            <div>
                                {[...Array(3)].map((_, index) => (
                                    <div className="mb-3" key={index}>
                                        <Skeleton height={100}/>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <div className="hospital-list" style={{maxHeight: '400px', overflowY: 'auto'}}>
                                {hospitals.length > 0 ? (
                                    hospitals.map((hospital) => (
                                        <Col lg={12} key={hospital.id}>
                                            <Card className="mb-1 p-2 shadow-sm card-hover">
                                                <CardBody
                                                    className="card-body d-flex justify-content-between align-items-center p-2">
                                                    <div className="row col-12 d-flex align-items-center">
                                                        <Avatar
                                                            src={process.env.REACT_APP_URL_STORAGE + "src/hospital_icone.png"}
                                                            size={60}
                                                            className="me-2 col-1"
                                                        />
                                                        <div className="col-5">
                                                            <h6 className="mb-1 fw-bold">{hospital?.name || hospital?.social_reason || "Local não informado"}</h6>
                                                            <p className="text-muted mb-0">
                                                                <i className="fa fa-map-marker text-info me-1"></i>
                                                                {hospital?.city_name || "Cidade não especificada"} / {hospital.uf || "UF não especificada"}
                                                            </p>
                                                            {hospital.phone_number && (
                                                                <p className="mb-0"
                                                                   style={{color: 'gray', fontSize: '0.9em'}}>
                                                                    <i className="fa fa-phone text-info me-1"></i> {hospital.phone_number}
                                                                </p>
                                                            )}
                                                        </div>
                                                        <div
                                                            className="col-4">
                                                            <div className="d-flex">

                                                                <div className="hospital-info flex-grow-1 ml-3">
                                                                    <p className="mb-0"
                                                                       style={{color: 'gray', fontSize: '0.9em'}}>
                                                                        {hospital.zip_code}
                                                                    </p>
                                                                    <p className="mb-0"
                                                                       style={{color: 'gray', fontSize: '0.9em'}}>
                                                                        {hospital.street_name}, {hospital.address_number}, {hospital.neighborhood_name}
                                                                    </p>

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-1">
                                                            <button
                                                                type="button"
                                                                className="mt-2 btn btn-primary sm"
                                                                onClick={() => handleSelectHospital(hospital)}
                                                            >
                                                                {actionText}
                                                            </button>
                                                        </div>


                                                    </div>


                                                </CardBody>
                                            </Card>
                                        </Col>
                                    ))
                                ) : (
                                    hasSearched ? ( // Mostra a mensagem de "Nenhum hospital encontrado" apenas após a busca
                                        <>
                                            { assistant?.can_edit_hospitals > 0 ? (
                                                <div className="alert alert-warning" role="alert">
                                                    <p>Nenhum local encontrado na pesquisa realizada</p>
                                                    <button type="button" onClick={() => handleModalRegister()}
                                                            className="btn btn-success">Novo Cadastro
                                                    </button>
                                                </div>
                                            ) : (
                                                <div className="alert alert-warning" role="alert">
                                                    <p>Nenhum hospital encontrado na pesquisa realizada</p>
                                                    <p>Criar um help desk para solicitar cadastramento</p>
                                                    <a href="/admin/help-desk" target="_blank"
                                                       className="btn btn-success">Help
                                                        Desk</a>
                                                </div>
                                            )}
                                        </>
                                    ) : (
                                        <div className="alert alert-info">
                                            Utilize os filtros acima para localizar os locais desejados.
                                        </div>
                                    )
                                )}
                            </div>
                        )}
                        <CustomPagination pagination={pagination}
                                          onChange={handlePageChange}/>
                    </Row>
                </Modal.Body>
            </Modal>
            <HospitalRegisterModal show={showModalHospitalRegister} initialData={null}
                                   onHide={handleCloseModalRegister}
            />
        </>
    );
};

export default HospitalModal;
